import { ListGroup } from "react-bootstrap";

function StudyManagementSidebar({ 
  collapseSidebar, 
  checkActiveTab, 
  handleAddNewTab 
}) {
  return (
    <>
      <ListGroup.Item action
        className={`border-0 border-bottom bg-light`}
        style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
      >
        <div className="hstack justify-content-between w-100">
          <span>
            <i className={`fa-solid fa-folder me-2`}></i>
            {!collapseSidebar && <span>Study Management</span>}
          </span>
        </div>
      </ListGroup.Item>
      <ListGroup.Item action
        className={`border-0 border-bottom ${checkActiveTab("studyDetail") && "selectedMenu"}`}
        style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
        onClick={() => { handleAddNewTab("Study Details", "fa-solid fa-clipboard-list", "studyDetail") }}
        title={"Study Details"}
      >
        <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
        {!collapseSidebar && <span>Study Details</span>}
      </ListGroup.Item>
      <ListGroup.Item action
        className={`border-0 border-bottom ${checkActiveTab("auditLogs") && "selectedMenu"}`}
        style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
        onClick={() => { handleAddNewTab("Audit Logs", "fa-solid fa-clipboard-list", "auditLogs") }}
        title={"Audit Logs"}
      >
        <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
        {!collapseSidebar && <span>Audit Logs</span>}
      </ListGroup.Item>
    </>
  );
}

export default StudyManagementSidebar;